export default __webpack_public_path__ + "static/media/auto.56af7e32.jpg";